<script>
import axios from 'axios'
import CryptoJS from "crypto-js"

const name = 'zxc123';

function copy(value){
  if(value){
    return JSON.parse(JSON.stringify(value))
  } else {
    return null
  }
}

function toCDB(value){
  var tmp = ""; 
  for(var i=0;i<value.length;i++){ 
    if (value.charCodeAt(i) == 12288){
      tmp += String.fromCharCode(value.charCodeAt(i)-12256);
      continue;
    }
    if(value.charCodeAt(i) > 65280 && value.charCodeAt(i) < 65375){ 
      tmp += String.fromCharCode(value.charCodeAt(i)-65248); 
    } 
    else{ 
      tmp += String.fromCharCode(value.charCodeAt(i)); 
    } 
  }
  return tmp 
}

function jsonConcat(o1, o2){
  for (var key in o2) {
    o1[key] = o2[key];
  }
  return o1;
}

function checkForm(list, requiredField){
  let result = true
  for(var key of requiredField){
    if(!list[key]){
      result = false
    }
  }
  return result
}

function encrypt(word, keyStr, ivStr) {
  const KEY = CryptoJS.enc.Utf8.parse("78afc8512559b62f");
  const IV = CryptoJS.enc.Utf8.parse("1234567890123456");
  
  let key = KEY
  let iv = IV

  if (keyStr) {
    key = CryptoJS.enc.Utf8.parse(keyStr);
    iv = CryptoJS.enc.Utf8.parse(ivStr);
  }

  let srcs = CryptoJS.enc.Utf8.parse(word);
  var encrypted = CryptoJS.AES.encrypt(srcs, key, {
    iv: iv,
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  // console.log("-=-=-=-", encrypted.ciphertext)
  return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
}

function decrypt(word, keyStr, ivStr) {
  const KEY = CryptoJS.enc.Utf8.parse("78afc8512559b62f");
  const IV = CryptoJS.enc.Utf8.parse("1234567890123456");
  let key = KEY
  let iv = IV

  if (keyStr) {
    key = CryptoJS.enc.Utf8.parse(keyStr);
    iv = CryptoJS.enc.Utf8.parse(ivStr);
  }

  let base64 = CryptoJS.enc.Base64.parse(word);
  let src = CryptoJS.enc.Base64.stringify(base64);

  var decrypt = CryptoJS.AES.decrypt(src, key, {
    iv: iv,
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });

  var decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
  return decryptedStr.toString();
}

async function getIpAddress(){
  const API_KEY = '64c12346152e44dea68ddd8695d3d77e';
  const API_URL = 'https://ipgeolocation.abstractapi.com/v1/?api_key=' + API_KEY;
  try {
    const response = await fetch(API_URL)
    const result = await response.json()
    return result 
  } catch (err) {
    console.log(err)
    this.$refs.ShowMsg.open(
      0,
      '系統錯誤',
      '請聯繫系統管理人員，編號為Pjt-7979'
    )
    return null 
  }
}

async function setSystemLog(ipAddress,userId,type,logContent,note1){
  let res = []
  var request = {
    method: 'POST',
    url: '/systemLog',
    params: {
      ipAddress: ipAddress,
      userId: userId,
      system: 'Admin',
      type: type,
      logContent: logContent,
      note1: note1,
    },
  }
  await axios(request)
    .then(function(response) {
      res = response.data.data
      // console.log('[Global][setSystemLog]res: ' + res)
    }).catch(()=>{
    }).finally(()=>{
    })
  return res
}

function getTypevDescription(list, value){
  var index = list.findIndex(function(item){return item.valuev == value})
  return (index != -1) ? list[index].name : null
}

async function getCategoryList(){
  let res = []
  var request = {
    method: 'GET',
    url: '/common/typevByCategory/category',
    params: {},
  }
  await axios(request)
    .then(function(response) {
      res = response.data.data
    }).catch(()=>{
    }).finally(()=>{
    })
  return res
}

async function getMonthStatusList(){
  let res = []
  var request = {
    method: 'GET',
    url: '/common/typevByCategory/monthStatus',
    params: {},
  }
  await axios(request)
    .then(function(response) {
      res = response.data.data
    }).catch(()=>{
    }).finally(()=>{
    })
  return res
}

async function getPmJobGradeList(){
  let res = []
  var request = {
    method: 'GET',
    url: '/pmJobGradeList',
    params: {},
  }
  await axios(request)
    .then(function(response) {
      res = response.data.data
    }).catch(()=>{
    }).finally(()=>{
    })
  return res
}

async function getPmSupervisorAllowanceList(){
  let res = []
  var request = {
    method: 'GET',
    url: '/pmSupervisorAllowanceList',
    params: {},
  }
  await axios(request)
    .then(function(response) {
      res = response.data.data
    }).catch(()=>{
    }).finally(()=>{
    })
  return res
}
export default
{
  name, //this.$Global.name

  //
  copy,
  toCDB,
  jsonConcat,
  checkForm,
  encrypt,
  decrypt,
  getTypevDescription,
  getIpAddress,
  setSystemLog,

  //[API]
  getCategoryList,
  getMonthStatusList,

  getPmJobGradeList,
  getPmSupervisorAllowanceList,
}
</script>